import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../lib/api-client';

/**
 * useRefreshFromErp — mutation disparada pelo verbo "Atualizar do conector".
 *
 * Após sucesso, invalida customer-context da conversation associada.
 * O WS event person.context.refreshed também invalida (via useCustomerContext)
 * — redundância proposital para responsividade.
 */
export function useRefreshFromErp(conversationId: string): {
  mutate: (personId: string) => void;
  isPending: boolean;
  isError: boolean;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (personId: string) => api.refreshPersonFromErp(personId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['customer-context', conversationId] });
    },
  });

  return {
    mutate: (personId: string) => mutation.mutate(personId),
    isPending: mutation.isPending,
    isError: mutation.isError,
  };
}
